<template>
  <b-modal id="modalResultsSearch" :title="$t('searchResults')" centered no-close-on-backdrop scrollable>
    <b-list-group v-if="type === 'T'">
      <b-list-group-item v-for="(item, i) in items" :key="i" :to="{ name: 'TournamentHome', params: { lang: lang, console: console, tournamentSlug: item.slug } }" target="_BLANK">{{ item.name }}</b-list-group-item>
    </b-list-group>
    <b-list-group v-if="type === 'D'">
      <b-list-group-item v-for="(item, i) in items" :key="i" :to="{ name: 'DivisionHome', params: { lang: lang, console: console, divisionSlug: item.slug } }" target="_BLANK">{{ item.name }}</b-list-group-item>
    </b-list-group>
    <b-list-group v-if="type === 'TE'">
      <b-list-group-item v-for="(item, i) in items" :key="i" :to="{ name: 'TeamHome', params: { lang: lang, console: console, teamSlug: item.slug } }" target="_BLANK">{{ item.name }}</b-list-group-item>
    </b-list-group>
    <b-list-group v-if="type === 'P'">
      <b-list-group-item v-for="(item, i) in items" :key="i" :to="{ name: 'PlayerHome', params: { lang: lang, console: console, playerSlug: item.slug } }" target="_BLANK">{{ item.nick }}</b-list-group-item>
    </b-list-group>
    <template slot="modal-footer">
      <b-button type="button" @click="$root.$emit('bv::hide::modal', 'modalResultsSearch')">{{ $t('close') }}</b-button>
    </template>
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    items: {
      required: true,
      type: Array
    },
    type: {
      required: true,
      type: String
    }
  },
  computed: {
    ...mapGetters(['lang', 'console'])
  }
}
</script>
